import { render, staticRenderFns } from "./c-cascader-industry-category.vue?vue&type=template&id=4b1b3c49&scoped=true"
import script from "./c-cascader-industry-category.vue?vue&type=script&lang=js"
export * from "./c-cascader-industry-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1b3c49",
  null
  
)

export default component.exports